<template>
  <div id="gene-tag-container" @mouseenter="e => mouse = true" @mouseleave="e => mouse = false">
    <input
      ref="comment-input"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="content"
      @focus="e => focus = true"
      @blur="e => focus = false"
      @keydown.up.prevent.stop="e => moveTagIndex('up')"
      @keydown.down.prevent.stop="e => moveTagIndex('down')"
      @keydown.enter.prevent.stop="e => genes.length <= 1 ? $emit('send', content) : commentTag()"
      @input="e => commentOnInput(true)"
      @change="e => $emit('change', content)"
    >
    <div class="input-tag" :style="tagWidth ? { 'min-width': tagWidth } : {}" v-if="genes && !onCompelete && display && content">
      <div class="tag-block">
        <template v-if="genes.length > 0">
          <div v-if="dataInfo && (dataInfo['gene'] || dataInfo['hpo'] || dataInfo['condition'] || dataInfo['panel'])" class="tag-info-container">
            <div class="tag-info-block">
              <span
                v-html="[
                ((dataInfo['gene'] || {}).displayed ? dataInfo['gene'].displayed + '/' + dataInfo['gene'].total + ' genes' : ''),
                ((dataInfo['panel'] || {}).displayed ? dataInfo['panel'].displayed + '/' + dataInfo['panel'].total + ' gene panels' : ''),
                ((dataInfo['hpo'] || {}).displayed ? dataInfo['hpo'].displayed + '/' + dataInfo['hpo'].total + ' phenotypes' : ''),
                ((dataInfo['condition'] || {}).displayed ? dataInfo['condition'].displayed + '/' + dataInfo['condition'].total + ' conditions' : '')
              ].filter(x => x).join(', ').replace(/,(?!.*,)/, ', and') + '.'"
              ></span>
            </div>
          </div>
          <div ref="tag-block" class="tag-group-container" :style="tagHeight ? { 'max-height': tagHeight } : {}">
            <div v-if="(filtedGenes['gene'] || []).length" class="tag-group-block">
              <div v-if="title" class="tag-title">Genes</div>
              <div class="tag" v-for="(tag, index) in filtedGenes['gene']" :key="index" :class="{ selected: tagIndex === index }" @mousemove="e => tagIndex = index" @click="commentTag()">
                <span v-html="tag.name.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
            <div v-if="(filtedGenes['panel'] || []).length" class="tag-group-block">
              <div v-if="title" class="tag-title">Panels</div>
              <div class="tag" v-for="(tag, index) in filtedGenes['panel']" :key="index - -(filtedGenes['gene'] || []).length" :class="{ selected: tagIndex === index - -(filtedGenes['gene'] || []).length }" @mousemove="e => tagIndex = index - -(filtedGenes['gene'] || []).length" @click="commentTag()">
                <span v-html="tag.name.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
                <span v-html="'<span style=color:#FA3D3D> (' + tag.gene_count + ' gene' + (tag.gene_count > 1 ? 's' : '') + ')</span>'"></span>
              </div>
            </div>
            <div v-if="(filtedGenes['hpo'] || []).length" class="tag-group-block">
              <div v-if="title" class="tag-title">Phenotypes</div>
              <div class="tag" v-for="(tag, index) in filtedGenes['hpo']" :key="index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length" :class="{ selected: tagIndex === index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length }" @mousemove="e => tagIndex = index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length" @click="commentTag()">
                <span v-html="tag.name.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
            <div v-if="(filtedGenes['condition'] || []).length" class="tag-group-block">
              <div v-if="title" class="tag-title">Conditions</div>
              <div class="tag" v-for="(tag, index) in filtedGenes['condition']" :key="index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length - -(filtedGenes['hpo'] || []).length" :class="{ selected: tagIndex === index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length - -(filtedGenes['hpo'] || []).length }" @mousemove="e => tagIndex = index - -(filtedGenes['gene'] || []).length - -(filtedGenes['panel'] || []).length - -(filtedGenes['hpo'] || []).length" @click="commentTag()">
                <span v-html="tag.name.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tab-empty">{{ 'No result has been found.'/* ___ */ }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    init: {
      type: String,
      default: () => ''
    },
    tagWidth: {
      type: String,
      default: () => ''
    },
    tagHeight: {
      type: String,
      default: () => ''
    },
    title: {
      type: Boolean,
      default: () => true
    },
    dataInfo: {
      type: Object,
      default: () => null
    },
    genes: {
      type: Array,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    noFocus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    }
  },
  computed: {
    filtedGenes () {
      return groupBy(this.genes, gene => gene.type, true)
    }
  },
  watch: {
    'init' () {
      if (this.content !== this.init) {
        this.content = this.init
      }
    },
    'focus' () {
      this.display = this.focus || this.mouse
    }
  },
  created () {
    if (this.content !== this.init) {
      this.content = this.init
    }
  },
  methods: {
    commentOnInput (compelete) {
      compelete && (this.onCompelete = false)
      this.tagIndex = 0
      this.$emit('input', this.content)
    },
    moveTagIndex (type) {
      switch (type) {
        case 'up': {
          this.tagIndex = (this.tagIndex - -this.genes.length - 1) % this.genes.length
          break
        }
        case 'down': {
          this.tagIndex = (this.tagIndex - -1) % this.genes.length
          break
        }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex
    },
    commentTag () {
      const curTag = this.genes[this.tagIndex]
      this.onCompelete = true
      this.content = curTag.name
      this.$emit('tag', curTag)
      this.commentOnInput()
      !this.noFocus && this.$refs['comment-input'].focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#gene-tag-container
  position: relative
  input
    width: 100%
    &:hover
      & + .description-tag
        .info-container
          opacity: 1
          top: 58px
    &:focus
      & + .description-tag
        .info-container
          opacity: 0
          top: -9999999999999999px
  .input-tag
    position: absolute
    width: 100%
    top: 36px
    overflow: hidden
    z-index: 5
    .tag-block
      width: 100%
      box-sizing: border-box
      padding: 5px 0
      background: white
      border-radius: 3px
      border: 1px solid #003679
      z-index: 100
      .tag-info-container
        width: 100%
        padding: 0 5px
        margin-bottom: 7px
        box-sizing: border-box
        .tag-info-block
          width: 100%
          padding: 3px 5px
          box-sizing: border-box
          background: #F8FAFA
          border-radius: 3px
          color: #003679
      .tag-group-container
        overflow-y: auto
        max-height: 400px
        .tag-group-block
          & > div
            width: 100%
          &:not(:last-child)
            margin-bottom: 8px
          .tag-title
            color: #003679
            margin-bottom: 7px
            padding: 0 10px
            font-weight: 500
            box-sizing: border-box
          .tag
            padding: 3px 10px
            cursor: pointer
            user-select: none
            box-sizing: border-box
            word-break: break-word
            &.selected
              background: #003679
              color: white
              .key
                color: white
            span
              white-space: pre
            .key
              color: #003679
      .tab-empty
        color: #999999
        font-weight: 300
        padding: 0 10px
</style>



// WEBPACK FOOTER //
// src/components/tool/geneTag.vue